export const scrollBodyToTop = () =>
  document.getElementById('root').scrollIntoView({ behavior: 'auto' });
